
















































































































































































































import Loading from 'vue-loading-overlay';
import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import {
    AuthStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    StoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import { FilterDateEvent } from '../../core/utils/types';
import { ColorsList, formattedDate, getCurrentTimestamp, getDateFromDateFormatApi, getObjectAsQueryString, getTimeOffset, goToUrl, isEmptyObject, NAME_ROUTES, PRIVILEGE_KEYS, PRIVILEGE_TYPES, sortObjectByPropertyName } from '../../core/utils';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import { formatComplexList, formatList } from '../../core/utils/table-formatters';
import Axios from 'axios';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { PageTitle } from '../../core/components';
import  Combobox from '../../core/components/Combobox.vue';
import  Input from '../../core/components/Input.vue';
import  Button from '../../core/components/Button.vue';
import  SectionTitle from '../../core/components/SectionTitle.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import ModalReportSuscription from '../components/ModalReportSuscription.vue';
import ModalDownloadExcel from '../components/ModalDownloadExcel.vue';
import ModalUploadExcel from '../components/ModalUploadExcel.vue';
import ModalReportSettings from '../components/ModalReportSettings.vue';
import { ActiveReports, parameterSubscriptionIdQuantity, parameterTimeOffsetQuantity, ReportActivation, seeDataStudioReport, SuscriptionsList, Template, TemplateParamsOptions, unsuscribeReport } from '../../core/models/';
import { ReportsServices } from '../../reports/api/ReportsServices';
import { AuthEvent } from '../../../store';
import { ActiveOptions } from '../../../features/insurance/options';

@Component({
    components: { 
        Loading, 
        PageTitle,
        SectionTitle,
        SimpleTable,
        Button,
        ModalReportSuscription,
        Combobox,
        ModalDownloadExcel,
        ModalReportSettings,
        Input,
        DeleteConfirmation,
        ModalUploadExcel
    }
})
export default class ReportsPage extends Mixins(
    StoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    NotificationStoreHelper,
    AuthStoreHelper
) {
    allCompanies: boolean = false;
    visibleModalDownloadExcel: boolean = false;
    visibleModalReportSuscription: boolean = false;
    visibleModalUploadExcel: boolean = false;
    visibleModalReportSettings: boolean = false;
    itemsTable: Array<SuscriptionsList> = [];
    templatesList: Array<Template> = [];
    search: string = '';
    uploadFileColor: string = ColorsList.purple;
    cantSubscribeMessage: string = 'Reporte no disponible para suscripción'
    headers: Array<object> = [
        {
            text: 'Tipo de Reporte',
            align: 'left',
            value: 'template.template_description',
            filter: this.filterByReportType,
            width: '320px'
        },
        {
            text: 'Empresa/s',
            align: 'left',
            value: 'subscriptions.companies',
            formatter: this.formatCompanies
        },
        {
            text: 'Estado de suscripción',
            align: 'center',
            value: 'is_active',
            filter: this.filterByReportState,
            width: '180px'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions',
            width: '250px'
        }
    ];
    pendingTemplates: boolean = false;
    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    templateIdToUnsuscribe: number = -1;
    reportTypesList: string[] = [];
    reportTypeSelected: object | null = null;
    filtersStateReportList: Array<object> = ActiveOptions;
    filterStateSelected: object | null = null;
    filtersStateRV: boolean = false;
    reportTypeSelectedRV: boolean = false;
    suscriptionData: SuscriptionsList | null = null;
    isEmptyObj: Function = isEmptyObject;
    suscriptionIdToRemove: number = 0;

    updateSettingsInReportList(
        template_id: SuscriptionsList["template"]["template_id"],
        new_settings: SuscriptionsList["settings"]
    ){
        let indexTemplateToUpdate = this.itemsTable.findIndex(item => item['template']['template_id'] === template_id);
        if(indexTemplateToUpdate !== -1){
            this.$set(this.itemsTable[indexTemplateToUpdate], 'settings', new_settings);
        }
    }

    closeModalReportSettings(){
        this.visibilityModalReportSettings(false);
    }

    showModalConfigureReport(item: SuscriptionsList){
        this.suscriptionData = item;
        this.visibilityModalReportSettings(true);
       console.log("showModalConfigureReport", item);
    }
    
    showRemoveReport(item: SuscriptionsList){
        this.confirmationDelete = true;
        this.deleteModalTitle = `Remover suscripción`;
        this.deleteBody = `¿Está seguro que desea remover la suscripción al reporte: <b>${item.template.template_description}</b>?<br>Si lo hace, ya no podrá acceder al reporte y deberá suscribirse nuevamente`;
        this.suscriptionIdToRemove = item.subscriptions.id;
    }

    userConfirmation(value: boolean){
        let suscriptionId = this.suscriptionIdToRemove;
         if (value) {
           this.confirmationDelete = false;
           this.removeSuscription(suscriptionId);
        } else {
           this.confirmationDelete = false;
        }
    }

    removeSuscription(suscriptionId: number){
        this.pendingRequest(true);
        ReportsServices.removeSuscription(
            suscriptionId
        ).then((res) => {
            this.$_showAddPointOfInterest(res.message);
            this.getActiveReports();
        }).catch((err) => {
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudo remover la suscripcion'
            })
        }).finally(() => {
            this.pendingRequest(false);
        })
    }

    seeReport(item: SuscriptionsList){
        let reportParams:SuscriptionsList['parameters'] = item['parameters'];
        let hasParams = !isEmptyObject(reportParams);

        if(hasParams){
            seeDataStudioReport(reportParams, item['template']['template_name']);
        }
    }

    showModalSuscription(subscription: SuscriptionsList){
        // console.log("showModalSuscription", subscription);
        this.suscriptionData = subscription;
        this.visibilityModalReportSuscription(true);
    }

    showModalUploadExcel(suscription: SuscriptionsList){
        this.suscriptionData = suscription;
        this.visibilityModalUploadExcel(true);
    }

    visibilityModalReportSuscription(value: boolean){
        this.visibleModalReportSuscription = value;
    }

    visibilityModalUploadExcel(value: boolean){
        this.visibleModalUploadExcel = value;
    }

    exportExcel(row:SuscriptionsList){
        // console.log("export excel");
        this.suscriptionData = row;
        this.visibilityModalDownloadExcel(true);
    }

    closeDownloadExcel(){
        this.visibilityModalDownloadExcel(false);
    }

    closeModalUploadExcel(){
        this.visibilityModalUploadExcel(false);
    }

    formatCompanies(value){
        return formatList(value, 'name');
    }


  
    filterByReportType(value) {
        return this.reportTypeSelected !== null ? value === this.reportTypeSelected['description'] : true;
    }

    filterByReportState(value) {
        return this.filterStateSelected !== null ? value === this.filterStateSelected['value'] : true;
    }


    updateFiltersStateRV(value){
        this.filtersStateRV = value;
    }

    updateFiltersSelected(value){
        this.filterStateSelected = value;
    }
    updateReportTypeSelected(value){
        this.reportTypeSelected = value;
    }
    updateFiltersReportTypeRV(value){
        this.reportTypeSelectedRV = value;
    }

    unsubscribe: () => void;

    created(){
        this.unsubscribe = this.$store.subscribe((mutation, stateList) => {
            if (mutation.type !== AuthEvent.SET_PRIVILEGES) return;
            this.checkPermissions();
        });
    }

    checkPermissions() {
        if (!this.shouldSeePanel) {
            this.$router.push(NAME_ROUTES.HOME.path);
        }
    }


    get shouldSeePanel(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.REPORTS_PANEL, PRIVILEGE_TYPES.READ);
    }
        
    @Watch('$route', { immediate: true, deep: true })
    onUrlChange() {
        this.getActiveReports();
    }


    removeSuscriptionFromList(){
        let indexTemplateToRemove = this.itemsTable.findIndex(item => item['id'] === this.templateIdToUnsuscribe);
        if(indexTemplateToRemove !== -1){
            this.itemsTable.splice(indexTemplateToRemove, 1);
            this.$_showAddPointOfInterest('Suscripción removida')
        }
        this.templateIdToUnsuscribe = -1;
    }

    visibilityModalDownloadExcel(value: boolean){
        this.visibleModalDownloadExcel = value;
    }

    visibilityModalReportSettings(value: boolean){
        this.visibleModalReportSettings = value;
    }

    createReport(){
        // console.log("create report");
    }

    get getCurrentCompany(){
        return this.$_getCurrentCompanyName
    }

    setSuscriptions(items:  Array<SuscriptionsList>){
        this.itemsTable = items;
    }

    pendingRequest(value){
        this.pendingTemplates = value;
    }



    getActiveReports(){
        this.pendingRequest(true);
        ReportsServices.getSuscriptionsByCompany()
        .then((res) => {
            this.setSuscriptions(res);
            this.pendingRequest(false);
        }).catch((err) => {
            this.setSuscriptions([]);
            this.pendingRequest(false);
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudo obtener la lista de suscripciones'
            })
        })
    }

    mounted() {
        this.getTemplatesList();
    }

    getTemplatesList(){
        ReportsServices.getTemplatesList()
        .then((res) => {
            this.templatesList = res['templates']
            this.templatesList = this.templatesList.sort(sortObjectByPropertyName('description'));
            // console.log("res", res);
        }).catch((err) => {
            this.templatesList = [];
            this.$_showHistoricalError('No se pudo obtener la lista de templates');
            // console.log("res", err);
        })
    }
}
